import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {
  AccountCreationSteps,
  FinancialAccountsCreationService
} from "@brightside-web/desktop/feature/financial-accounts-core";

@Component({
    selector: 'brightside-web-savings-account-verification',
    templateUrl: './savings-account-verification.component.html',
    styleUrls: ['./savings-account-verification.component.css'],
    standalone: false
})
export class SavingsAccountVerificationComponent {

  productType = 'payrollSavings';
  routeOnSuccess = ['../consents'];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private faCreateSvc: FinancialAccountsCreationService
  ) {}

  submitAction() {
    this.faCreateSvc.advanceStep(AccountCreationSteps.VERIFICATION);
    this.router.navigate(this.routeOnSuccess, { relativeTo: this.route });
  }

}
